
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";

const Features = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center mb-8 text-primary animate-fade-in">
            Our Features
          </h1>
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
            Discover the powerful capabilities that make our AI solutions stand out.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "AI-Powered Analytics",
                description: "Advanced machine learning algorithms provide deep insights into your data.",
                icon: "📊"
              },
              {
                title: "Real-time Processing",
                description: "Process and analyze data in real-time for immediate insights.",
                icon: "⚡"
              },
              {
                title: "Custom Integration",
                description: "Seamlessly integrate with your existing systems and workflows.",
                icon: "🔄"
              }
            ].map((feature, index) => (
              <div 
                key={feature.title}
                className="p-6 bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-accent transform hover:-translate-y-1"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="text-4xl mb-4 text-primary">{feature.icon}</div>
                <h3 className="text-xl font-semibold mb-4 text-primary">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-20">
            <h2 className="text-3xl font-bold text-center mb-8 text-primary">
              Why Choose Us?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-8 bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-accent">
                <h3 className="text-xl font-semibold mb-4 text-primary">Enterprise-Grade Security</h3>
                <p className="text-gray-600">
                  Your data is protected with state-of-the-art security measures and compliance standards.
                </p>
              </div>
              <div className="p-8 bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-accent">
                <h3 className="text-xl font-semibold mb-4 text-primary">24/7 Support</h3>
                <p className="text-gray-600">
                  Our dedicated team is always available to help you with any questions or issues.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Features;
